import axios from 'axios';
// import { ElMessageBox } from 'element-plus'; // 弹窗相关去掉

let tokenPromise = null;
// let isAlerting422 = false; // 弹窗相关去掉

/**
 * 获取 eformHomeToken，forceRefresh=true 时强制请求新 token
 */
async function getEformHomeToken(forceRefresh = false) {
  let token = localStorage.getItem('eformHomeToken');
  let expireTime = localStorage.getItem('eformHomeTokenExpire');
  const now = Date.now();

  // 如果不是强制刷新，且本地 token 未过期，直接用本地
  if (!forceRefresh && token && expireTime && now < new Date(expireTime).getTime()) {
    return token;
  }

  // 保证并发只请求一次
  if (!tokenPromise) {
    tokenPromise = axios.post('/api/eform_home/createToken').then(res => {
      if (res.data && res.data.token) {
        token = res.data.token;
        expireTime = res.data.expire_time;
        localStorage.setItem('eformHomeToken', token);
        localStorage.setItem('eformHomeTokenExpire', expireTime);
        return token;
      } else {
        throw new Error('Failed to get eform_home token');
      }
    }).finally(() => {
      tokenPromise = null;
    });
  }
  return tokenPromise;
}

const eformHomeHttp = axios.create({
  baseURL: '/api',
});

eformHomeHttp.interceptors.request.use(async config => {
  let token = localStorage.getItem('eformHomeToken');
  let expireTime = localStorage.getItem('eformHomeTokenExpire');
  const now = Date.now();

  if (!token || !expireTime || now >= new Date(expireTime).getTime()) {
    token = await getEformHomeToken();
  }
  config.headers['Eform-Authorization'] = `${token}`;
  const apiToken = localStorage.getItem('authToken');
  if (apiToken) {
    config.headers['Authorization'] = `Bearer ${apiToken}`;
  }
  return config;
});

eformHomeHttp.interceptors.response.use(
  response => response,
  async error => {
    if (
      error.response &&
      error.response.status === 422 &&
      error.response.data
    ) {
      // 不弹窗，直接刷新 token 并重试
      const originalRequest = error.config;
      if (!originalRequest._retry) {
        originalRequest._retry = true;
        // 关键：强制刷新 token，跳过本地缓存
        const token = await getEformHomeToken(true);
        originalRequest.headers['Eform-Authorization'] = `${token}`;
        // 如果有 Authorization 也同步刷新
        const apiToken = localStorage.getItem('authToken');
        if (apiToken) {
          originalRequest.headers['Authorization'] = `Bearer ${apiToken}`;
        }
        return eformHomeHttp(originalRequest);
      }
    }
    return Promise.reject(error);
  }
);

export default eformHomeHttp;